import React from "react";
import RowBasic from "./RowBasic";
import ProgressBar from "./ProgressBar";
import SpacingVertical from "../SpacingVertical";
import "./Link.css";

interface RowPredictionResultProps {
  name: string;
  confidence: number;
}

const RowPredictionResult = (props: RowPredictionResultProps) => {
  const { name, confidence } = props;
  const accessoryTitle = confidence.toFixed(3).toString();
  return (
    <div className="link">
      <RowBasic title={name.toLowerCase()} accessoryTitle={accessoryTitle} />
      <SpacingVertical rems={0.5} />
      <ProgressBar fraction={confidence} />
    </div>
  );
};

export default RowPredictionResult;
